module.exports = __webpack_public_path__ + "img/cori-gold.39f988c3.svg";